import React from 'react';
import { ErrorPage } from 'status/components/pages';

const Unauthorized = () => <ErrorPage message='You are not authorized to view this page.' />;

export default Unauthorized;
